// import { Component, ViewChild, AfterViewChecked, ChangeDetectorRef } from '@angular/core';
// import { NavController, NavParams } from 'ionic-angular';
import { DIC } from '../../../dic';
import { GN } from '../../../../gn';
import { Component, Input, ViewChild, ElementRef, Renderer, AfterViewChecked, ChangeDetectorRef } from '@angular/core';
import { NavController, PopoverController, NavParams, ViewController, ModalController } from 'ionic-angular';


/**
 * Generated class for the SearchemployeePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-searchemployee',
  templateUrl: 'searchemployee.html',
})
export class SearchemployeePage implements AfterViewChecked {
  @ViewChild('mySearchInput') mySearchInput;
  drivers: any
  radioDriver: any;
  driveridIf: any
  needsFocus: boolean;

  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN, private _changeDetectionRef: ChangeDetectorRef) {
    this.drivers = navParams.get('gr')
    this.driveridIf = navParams.get('didd')
    // console.log(this.driveridIf, ' this. this.driveridIf')

    if (this.driveridIf != -1) {
      this.radioDriver = this.driveridIf
    }
    this.resetSearch()


  }

  ionViewDidEnter() {

    this.needsFocus = true;
  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad SearchemployeePage');
    // this.mySearchInput.setFocus();
    // this.mySearchInput.setFocus()
    this.mySearchInput.setFocus();

    // console.log(this.mySearchInput.setFocus())

  }

  public ngAfterViewChecked(): void {
    if (this.needsFocus) {
      this.needsFocus = false;
      this.mySearchInput.setFocus();
      this._changeDetectionRef.detectChanges();
    }
  }

  // ngAfterViewChecked() {
  //   this.mySearchInput.setFocus()
  // }


  resetSearch() {
    for (var i = 0; i < this.drivers.length; i++) {
      this.drivers[i].Visible = true
    }
  }
  getItems(ev: any) {
    var val = ev.target.value;
    if (val == null) { val = '' }
    val = val.toLowerCase()
    this.searchClients(val);

  }


  fullnameclick(_id) {
    this.radioDriver = _id
    this.navCtrl.pop()
  }

  searchClients(val) {
    if (val && val.trim() != '') {
      for (var i = 0; i < this.drivers.length; i++) {
        var idStr = this.drivers[i].id + '';
        if (idStr.indexOf(val) > -1) {
          this.drivers[i].Visible = true
        }
        else
          if (this.gn._latcyr(this.drivers[i].name.toLowerCase()).indexOf(val) > -1 || this.gn._cyrlat(this.drivers[i].name.toLowerCase()).indexOf(val) > -1) {
            this.drivers[i].Visible = true
          } else {
            this.drivers[i].Visible = false
          }
      }
    }
    else {
      this.resetSearch()
    }
  }

  pressEnter(_ev: any) {
    for (let i = 0; i < this.drivers.length; i++) {
      if (this.drivers[i].Visible == true) {
        this.radioDriver = this.drivers[i].id
        break
      }
    }
    this.navCtrl.pop()
  }

  ionViewDidLeave() {
    var cb = this.navParams.get('cb')
    // console.log(this.radioDriver, 'radioDriver')
    var fullname = ''
    for (let i = 0; i < this.drivers.length; i++) {
      if (this.radioDriver == this.drivers[i].id) {
        fullname = this.drivers[i].name
        break

      }
    }
    // console.log(fullname, 'od vtora sttrana')
    cb(this.radioDriver, fullname)

  }



}



// WEBPACK FOOTER //
// ./src/pages/routing/routebank/choosedriverbank/searchemployee.ts